<template lang="html">
  <v-dialog
    v-model="ReportDialog"
    scrollable
    persistent
    :overlay="false"
    max-width="900px"
    transition="dialog-transition"
  >
    <v-card>
      <v-toolbar dark color="#3076d2">
        <v-toolbar-title>สถานะผู้อ่าน</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text style="height: 500px;">
        <v-tabs fixed-tabs icons-and-text v-model="tabs">
          <v-tab href="#tab-1" :key="1">
            จำนวนผู้อ่านแล้ว
            <v-icon>mdi-account-multiple</v-icon>
          </v-tab>
          <!-- <v-tab href="#tab-2" :key="2">
            จำนวนผู้รออ่าน
            <v-icon>mdi-account-multiple</v-icon>
          </v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tabs" class="white elevation-1">
          <v-tab-item id="tab-1">
            <b class="ma-3">รวมทั้งหมด ({{listfriend.length - 1}} ราย)</b>
            <v-layout justify-start row wrap align-center>
              <v-flex class="ma-3" xs4 sm4 md4 xl4 lg4 v-for="(item, index) in listReport" :key="index">
                <v-layout row wrap justify-center align-center>
                  <v-avatar
                    size="40"
                  >
                  <img :src="item.profilepicture" v-if="item.profilepicture" class="alligator-turtle">
                  <v-img :src="require('../../../assets/robot1.png')" v-else class="alligator-turtle border-img"></v-img>
                  </v-avatar>
                  <v-layout column wrap>
                    <p class="text-overflow mb-0">{{item.nickname}}</p>
                    <p class="text-overflow mb-0 color-gray fz-12" v-if="item.status">{{item.status}}</p>
                    <!-- <p class="text-overflow mb-0 color-gray fz-12" v-else>-</p> -->
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 class="ml-3 mr-3">
                <v-progress-linear :indeterminate="progress" v-if="progress" color="#3076d2"></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <!-- <v-tab-item id="tab-2">
            ppppp
          </v-tab-item> -->
        </v-tabs-items>
      </v-card-text>
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat @click="closeDialog()">Disagree</v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
var _ = require('lodash')
export default {
  props: {
    ReportDialog: Boolean,
    listfriend: Array,
    count_room: Number
  },
  data () {
    return {
      tabs: 'tab-1',
      listReport: [],
      progress: false
    }
  },
  watch: {
    ReportDialog () {
      console.log(this.ReportDialog)
      if (this.ReportDialog) {
        // console.log(this.listfriend)
        // console.log(this.count_room)
        this.getReport()
      }
    }
  },
  methods: {
    closeDialog () {
      this.listReport = []
      this.$emit('closeDialog', false)
    },
    getReport () {
      var size = 2
      var arrayOfArrays = []
      for (var i = 0; i < this.listfriend.length; i += size) {
        arrayOfArrays.push(this.listfriend.slice(i, i + size))
      }
      // console.log(arrayOfArrays)
      this.progress = true
      for (var j = 0; j < arrayOfArrays.length; j++) {
        this.axios.post(process.env.VUE_APP_API_OFFICIAL + `/read-user`, {
          list_tokenuser: arrayOfArrays[j]
        }).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data.data)
            // this.listReport = this.listReport.push(response.data.data)
            this.listReport.unshift.apply(this.listReport, response.data.data)
            this.listReport = _.unionBy(this.listReport, 'tokenuser')
            // console.log(j)
            // console.log(j === (arrayOfArrays.length - 1))
            // if (j === (arrayOfArrays.length - 1)) {
            //   this.progress = false
            // }
            this.progress = false
          }
        }).catch(error => {
          this.progress = false
          console.log(error)
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
>>>.elevation-1 {
  box-shadow: none !important;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100px;
  padding-left: 15px;
}
.border-img {
  border-color: #80808024;
  border-style: solid;
  border-width: thin;
}
.color-gray {
  color: gray;
}
.fz-12 {
  font-size: 12px;
}
</style>
